export const DEFAULT_COUNTRY_CODE_2 = 'AU';
export const DEFAULT_COUNTRY_CODE_3 = 'AUD';
